import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import {
  PLAY_MODEL_ACTION_DEFINITIONS,
  PLAY_MODEL_HELP_EXAMPLES,
  PLAY_MODEL_POSITION_DEFINITIONS,
} from './play-model-reference';

@Component({
  selector: 'app-play-model-help-modal',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
  ],
  templateUrl: './play-model-help-modal.component.html',
  styleUrls: ['./play-model-help-modal.component.scss'],
})
export class PlayModelHelpModalComponent {
  readonly positions = PLAY_MODEL_POSITION_DEFINITIONS;
  readonly actions = PLAY_MODEL_ACTION_DEFINITIONS;
  readonly examples = PLAY_MODEL_HELP_EXAMPLES;

  constructor(
    private dialogRef: MatDialogRef<PlayModelHelpModalComponent>
  ) {}

  close(): void {
    this.dialogRef.close();
  }
}
